import { render, staticRenderFns } from "./DueTickets.vue?vue&type=template&id=8ef565de&scoped=true&lang=pug"
import script from "./DueTickets.vue?vue&type=script&lang=js"
export * from "./DueTickets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ef565de",
  null
  
)

export default component.exports